import { usePageStore } from '@/store';
import util from '../../common/util';
import * as TYPES from './_store/types';
import { formats } from '../../common/format';


function decorateData(list = [], currencySymbol) {
    /**
     *  STATUS(3, "status change"),
        PRICE(2, "price change"),
        NEW(1, "new listing");
     */
    let i = 0,
        item,
        prev,
        next,
        ret = [];
    while ((item = list[i++])) {
        //new => old
        if (!item.price) {
            continue;
        } //filter out price == 0
        if (
            !prev ||
            prev.date != item.createTime ||
            (prev.updateType == 3 && item.updateType == 1)
        ) {
            ret.push(
                (prev = {
                    updateType: item.updateType,
                    event:
                        item.updateType == 2
                            ? 'Price Changed'
                            : item.updateType == 1
                                ? 'Listed'
                                : item.status == 'Active'
                                    ? 'Listed'
                                    : item.status,
                    price: parseInt(item.price),
                    date: item.createTime,
                    showPrice: formats.currency({
                        value: parseInt(item.price),
                        noSpace: true,
                        currencySymbol: currencySymbol
                    })
                })
            );
            continue;
        }
        // merge
        if (prev.updateType == item.updateType) {
            continue;
        }
        if (prev.updateType == 2) {
            prev.event =
                item.updateType == 1
                    ? 'Listed'
                    : item.status == 'Active'
                        ? 'Listed'
                        : item.status;
        }
    }
    for (i = 0; (item = ret[i++]) && (next = ret[i]);) {
        if (item.price != next.price) {
            item.diff = (
                ((item.price - next.price) * 100) /
                next.price
            ).toFixed(1);
            if (!parseFloat(item.diff)) {
                item.diff = undefined;
            }
        } else {
            item.showPrice = '-';
        }
    }
    return ret;
}

function findSource(mlsOrgId, listingDetail, pageMlsOrgs) {
    let mlsOrg;
    if ((mlsOrg = listingDetail?.info?.mlsOrg) && mlsOrg.id == mlsOrgId) {
        return mlsOrg.name; //house mls
    }
    if ((mlsOrg = findSiteMLS(mlsOrgId, pageMlsOrgs))) {
        return mlsOrg.name; //global mls
    }
    return 'MLS';
}


function findSiteMLS(id, pageMlsOrgs) {
    let i = 0,
        mlsOrg;
    if (!pageMlsOrgs) {
        return;
    }
    for (; (mlsOrg = pageMlsOrgs[i++]);) {
        if (mlsOrg.id == id) {
            return mlsOrg;
        }
    }
}

export async function asyncData(store) {
    const pageStore = usePageStore(this.$pinia);
    let getData = null;
    let pageMlsOrgs = pageStore.page.mlsOrgs;
    this.listingDetail = this.listingDetail || {};
    if (util.inCmsPageEditor && !this.isLandingpage) {
        getData = import(
            /* webpackChunkName: "history_mock"*/ './csm_mock'
        );
    } else {
        let info = this.listingDetail && this.listingDetail.info;
        if (!info) {
            return;
        }
        //mls org setting: Show Sale History
        let mlsOrg = findSiteMLS(info.mlsOrgId, pageMlsOrgs);
        if (mlsOrg && !mlsOrg.showSaleHistory) {
            return;
        }
        getData = store[TYPES.GET_HISTORYS]({
            info: info,
            isSold: !info.purchaseType
        })
    }
    let data = await getData;
    store[TYPES.SET_HISTORYS](decorateData(data.changeRecords, pageStore.currency?.symbol))
    let m = await store[TYPES.GET_MLS](data.mlsOrgId);
    store[TYPES.SET_SOURCE](findSource(data.mlsOrgId, this.listingDetail, pageMlsOrgs) || m);
}